import { Skeleton, Stack } from '@mui/material';

import {
	MplInvoiceListItemSkeleton,
	MplListItemSkeleton,
	MplTabsSkeleton,
} from '@mopla/ui';

import { StyledDownloadInvoicesListWrapper } from './DownloadInvoices.styled';

export const DownloadInvoicesSkeleton = () => {
	return (
		<Stack gap={2} sx={{ flex: 1, minHeight: 0 }}>
			<Stack gap={0.5}>
				<Skeleton variant="rounded" width="45%" height={26} animation="pulse" />
				<Skeleton variant="rounded" width="95%" height={18} animation="pulse" />
			</Stack>

			<MplTabsSkeleton />

			<StyledDownloadInvoicesListWrapper>
				{[1, 2, 3, 4, 5, 6].map((i) => (
					<MplInvoiceListItemSkeleton key={i} />
				))}
			</StyledDownloadInvoicesListWrapper>

			<MplListItemSkeleton />
		</Stack>
	);
};
